module.exports = "/_next/static/images/rainbow_menu_top-2c369243673c68ad0f8e95b31f21923d.jpg";